export enum ImageTypes {
  UPLOAD_IMAGES_REQUEST = 'UPLOAD_IMAGES_REQUEST',
  UPLOAD_IMAGES_REQUEST_SUCCESS = 'UPLOAD_IMAGES_REQUEST_SUCCESS',
  UPLOAD_IMAGES_REQUEST_FAILURE = 'UPLOAD_IMAGES_REQUEST_FAILURE',

  RESET_UPLOAD_IMAGES_REQUEST = 'RESET_UPLOAD_IMAGES_REQUEST',
}
